/**
 * O fim da tela Enviar documentos antes do caso (E144.F3): os avisos do envio e o rodapé com
 * Voltar e a ação principal. Saíram do `EnviarSemCaso` para ele caber no teto de linhas.
 */
import { Button } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';

import { BOTAO_DO_RODAPE, RODAPE_DA_JORNADA } from './PecasDaAbertura';

const t = ptBR.abertura;

export function AvisosDoEnvio({ erro }: { erro: string | null }): JSX.Element | null {
  if (erro === null) return null;
  return (
    <p
      id="abertura-erro"
      role="alert"
      data-testid="abertura-erro"
      className="border border-danger bg-danger-50 px-3 py-2 text-body-sm text-danger-700"
    >
      {erro}
    </p>
  );
}

/**
 * "Voltar aos casos" à esquerda e "Continuar" à direita, abaixo do conteúdo (v6.7; o nome é o do
 * HTML 6.8, E165.F1.T03). E177.F4 (GUS-253): o Contrato Digital também continua daqui — para a tela
 * "Contratos digitais" —, e a identificação do cliente incompleta segura o botão (`travado`), com o
 * aviso do porquê acima do rodapé.
 */
export function RodapeDoEnvio({
  abrindo,
  travado = false,
  onVoltar,
}: {
  abrindo: boolean;
  travado?: boolean;
  onVoltar: () => void;
}): JSX.Element {
  return (
    <>
      <p
        role="status"
        data-testid="abertura-continuar-bloqueio"
        className={travado ? 'text-[14px] text-fg' : 'hidden'}
      >
        {travado ? t.semIdentificacao : ''}
      </p>
      <div className={RODAPE_DA_JORNADA}>
        <Button
          type="button"
          variant="secondary"
          className={BOTAO_DO_RODAPE}
          onClick={onVoltar}
          disabled={abrindo}
        >
          {t.voltarAosCasos}
        </Button>
        <Button
          type="submit"
          className={BOTAO_DO_RODAPE}
          data-testid="abertura-continuar"
          disabled={abrindo || travado}
        >
          {abrindo ? t.abrindo : t.continuar}
        </Button>
      </div>
    </>
  );
}
